export default __webpack_public_path__ + "static/Logo_Humero_Small-c165d5007b7a6510bac7d74227fd982f.png";